import { render, staticRenderFns } from "./HouseBLPage.vue?vue&type=template&id=06ccf46f&scoped=true&"
import script from "./HouseBLPage.vue?vue&type=script&lang=js&"
export * from "./HouseBLPage.vue?vue&type=script&lang=js&"
import style0 from "./HouseBLPage.vue?vue&type=style&index=0&id=06ccf46f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ccf46f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ccf46f')) {
      api.createRecord('06ccf46f', component.options)
    } else {
      api.reload('06ccf46f', component.options)
    }
    module.hot.accept("./HouseBLPage.vue?vue&type=template&id=06ccf46f&scoped=true&", function () {
      api.rerender('06ccf46f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/houseBL/HouseBLPage.vue"
export default component.exports